import styled from 'styled-components'

import AppLinkMobileCtrl from 'Components/AppLinkMobileCtrl'
import Flex from 'Components/Flex'
import { _FavoriteBtn } from 'Components/Favourites/FavouriteStar/styles'
import { OUTLINE_COLOR } from '@CSSVars/colors'

export const _BuildingPreview = styled(AppLinkMobileCtrl)`
  text-decoration: none;
  padding-bottom: 0.25rem;
  div {
    border-radius: 10px;
  }
`

export const _Title = styled.div`
  color: black;
  font-weight: 600;
  font-size: 18px !important;
  line-height: 22px;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0;
  margin-top: 12px;
  ${({ customTitleCss }) => (customTitleCss)};
  @media screen and (max-width: 1440px) {
    font-size: 1.2rem;
  }
`

export const _BuildingFavouriteStar = styled(_FavoriteBtn)`
  right: 20px;
`

export const _AddressBlock = styled.div`
  display: flex;
  margin-top: 2px;

  @media screen and (max-width: 1440px) {
    flex-direction: column;
  }
`

export const _Address = styled.div`
  display: flex;
  line-height: 22px;
`

export const _ListingCounts = styled(Flex)`

  div {
    font-size: 12px;
    line-height: 22px;
    font-weight: 600;

    &:nth-child(2){
      padding: 0 5px;
      color: ${OUTLINE_COLOR};
    }
  }
`

export const _Distance = styled.div`
  font-size: 12px;
  display: none;
  line-height: 22px;
  margin-top: 5px;
`
export const _PreconStatus = styled.div`
  height: 22px;
  font-size: 12px;
  font-weight: 600;
  line-height: 22px;
  margin-bottom: 20px;
`
